export const devices = {
  desktop: "desktop",
  tab: "tab",
  mobile: "mobile"
};

export const getDevice = () => {
  if (window.innerWidth > 1800) return devices.desktop;
  else if (window.innerWidth < 575) return devices.mobile;
  else return devices.tab;
};
